/*
  Arrows and dots for the image-hotspots panel.

  The section already has working hotspot buttons on the image and its own
  script that swaps the panel content when one is pressed. Rather than
  duplicate that, these controls simply click the relevant hotspot button —
  so which hotspot is active stays in one place and cannot drift.
*/

(function () {
  'use strict';

  function HotspotPanel(root) {
    this.root = root;
    this.buttons = Array.prototype.slice.call(root.querySelectorAll('.tooltip-button'));
    if (this.buttons.length < 2) return;

    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hotspot-dot]'));
    this.index = 0;

    var prev = root.querySelector('[data-hotspot-prev]');
    var next = root.querySelector('[data-hotspot-next]');
    if (prev) prev.addEventListener('click', this.step.bind(this, -1));
    if (next) next.addEventListener('click', this.step.bind(this, 1));

    this.dots.forEach(
      function (dot, i) {
        dot.addEventListener('click', this.go.bind(this, i));
      }.bind(this)
    );

    // A hotspot pressed directly on the image must move the dots too.
    this.buttons.forEach(
      function (button, i) {
        button.addEventListener(
          'click',
          function () {
            this.index = i;
            this.paint();
          }.bind(this)
        );
      }.bind(this)
    );

    this.paint();
  }

  HotspotPanel.prototype.go = function (i) {
    var count = this.buttons.length;
    // wrap, so the arrows never dead-end
    this.index = ((i % count) + count) % count;
    this.buttons[this.index].click();
    this.paint();
  };

  HotspotPanel.prototype.step = function (direction) {
    this.go(this.index + direction);
  };

  HotspotPanel.prototype.paint = function () {
    this.dots.forEach(
      function (dot, i) {
        dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      }.bind(this)
    );
  };

  function init(scope) {
    (scope || document).querySelectorAll('image-hotspots').forEach(function (el) {
      if (el.hotspotPanel) return;
      el.hotspotPanel = new HotspotPanel(el);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init.bind(null, undefined));

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
